import axios from "axios";
import routes from "../app/routes";

export const policyPlanCustomRecordTemplateActions = {
  load: (dispatch) => {
    axios
      .get(routes.api.policy_plan_custom_record_templates.index)
      .then((resp) => {
        dispatch({ type: "load", collection: resp.data.data });
      });
  },
  save: (dispatch, templateId, values, successCallback, errorCallback) => {
    if (templateId == 0) {
      axios
        .post(routes.api.policy_plan_custom_record_templates.create, values)
        .then((resp) => {
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    } else {
      axios
        .put(
          routes.api.policy_plan_custom_record_templates.update(templateId),
          values
        )
        .then((resp) => {
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },
  delete: (dispatch, templateId) => {
    axios
      .delete(
        routes.api.policy_plan_custom_record_templates.destroy(templateId)
      )
      .then((resp) => {
        dispatch({
          type: "delete",
          templateId: templateId,
        });
      });
  },
  showCreateForm: (dispatch) => {
    dispatch({ type: "showModal", currentTemplate: null });
  },
  showEditForm: (dispatch, row) => {
    dispatch({ type: "showModal", currentTemplate: row });
  },
  hideModal: (dispatch) => {
    dispatch({ type: "hideModal" });
  },
};
